export const originConfig = {
  ADMIN_ADD: { name: '後台贈送', value: 'ADMIN_ADD' },
  ADMIN_USE: { name: '後台扣除', value: 'ADMIN_USE' },
  EXPIRED: { name: '過期', value: 'EXPIRED' },
  MEMBER_STORE_USE: { name: '點數兌換', value: 'MEMBER_STORE_USE' },
  REWARD_ACTIVITY_SALE_RECORD_ADD: { name: '銷售回饋', value: 'REWARD_ACTIVITY_SALE_RECORD_ADD' },
  REWARD_ACTIVITY_SALE_RECORD_ADD_CANCEL: { name: '銷售回收', value: 'REWARD_ACTIVITY_SALE_RECORD_ADD_CANCEL' },
  REWARD_ACTIVITY_MEMBER_STORE_ADD: { name: '商城回饋', value: 'REWARD_ACTIVITY_MEMBER_STORE_ADD' },
  REWARD_ACTIVITY_MEMBER_STORE_ADD_CANCEL: { name: '商城回收', value: 'REWARD_ACTIVITY_MEMBER_STORE_ADD_CANCEL' },
  REWARD_ACTIVITY_MEMBER_EXTERNAL_TRANSACTION_ADD: { name: '消費回饋', value: 'REWARD_ACTIVITY_MEMBER_EXTERNAL_TRANSACTION_ADD' },
  REWARD_ACTIVITY_MEMBER_EXTERNAL_TRANSACTION_ADD_CANCEL: { name: '消費回收', value: 'REWARD_ACTIVITY_MEMBER_EXTERNAL_TRANSACTION_ADD_CANCEL' },
  LOTTERY_AWARD_ADD: { name: '抽獎活動獲得', value: 'LOTTERY_AWARD_ADD' },
  MEMBER_GAME_USE: { name: '抽獎活動使用', value: 'MEMBER_GAME_USE' },
  REWARD_ACTIVITY_EC_ORDER_ADD: { name: '電商回饋', value: 'REWARD_ACTIVITY_EC_ORDER_ADD' },
  REWARD_ACTIVITY_EC_ORDER_ADD_CANCEL: { name: '電商回收', value: 'REWARD_ACTIVITY_EC_ORDER_ADD_CANCEL' },
  SERIAL_ACTIVITY_ADD: { name: '序號登錄獲得', value: 'SERIAL_ACTIVITY_ADD' },
  EVENT_PLAYBOOK_SEND: { name: '系統行銷活動發放', value: 'EVENT_PLAYBOOK_SEND' },
  EVENT_PLAYBOOK_CANCEL: { name: '系統行銷活動回收', value: 'EVENT_PLAYBOOK_CANCEL' },
  EXTEND_IN: { name: '點數展延-當年度轉入', value: 'EXTEND_IN' },
  EXTEND_OUT: { name: '點數展延-當年度轉出', value: 'EXTEND_OUT' },
  SHOP_POINT_LINK_ADD: { name: '點數連結', value: 'SHOP_POINT_LINK_ADD' },
  REWARD_DISTRIBUTION_ADD: { name: '獎勵活動發放', value: 'REWARD_DISTRIBUTION_ADD' },
  MEMBER_BENEFIT_ADD: { name: '會員權益發放', value: 'MEMBER_BENEFIT_ADD' },
  SALE_RECORD_USE: { name: '銷售使用', value: 'SALE_RECORD_USE' },
  SALE_RECORD_USE_CANCEL: { name: '取消銷售使用', value: 'SALE_RECORD_USE_CANCEL' },
  MEMBER_LEVEL_GIFT_ADD: { name: '等級禮發放', value: 'MEMBER_LEVEL_GIFT_ADD' },
}

export const pointLinkStatusConfig = {
  wait: { label: '已排程', value: 'wait', tagType: 'warning' },
  open: { label: '進行中', value: 'open', tagType: 'action' },
  finish: { label: '已結束', value: 'finish', tagType: 'info' },
}

export const usedPointStatusConfig = {
  used: { label: '已領取', value: 'used', tagType: 'action' },
  unused: { label: '未領取', value: 'unused', tagType: 'info' },
}
